(function () {
  'use strict';

  const path = window.location.pathname.replace(/\/$/, '');

  const isBloomCircle = path === '/products/bloom-circle-membership';
  const isFounding100 = path === '/products/the-founding-100-membership';

  if (!isBloomCircle && !isFounding100) return;

  function updateWording() {
    const widget = document.querySelector(
      '.shopify_subscriptions_app_block'
    );

    if (!widget) return;

    widget.querySelectorAll('.title_and_price_wrapper span').forEach(function (el) {
      const text = el.textContent.trim();

      if (isBloomCircle && text === 'Deliver every month') {
        el.textContent = 'Billed monthly';
      }

      if (isFounding100 && text === 'Deliver every year') {
        el.textContent = 'Billed annually';
      }
    });
    if (isFounding100) {
    const purchaseButton = document.querySelector(
      'product-form button[name="add"]'
    );

    if (purchaseButton) {
      const selectedPlan = document.querySelector(
        '.shopify_subscriptions_app_block input[type="radio"]:checked'
      );

      const isSubscription = selectedPlan &&
        selectedPlan.closest('.subscription_group');

      const buttonText = purchaseButton.querySelector('span');

      if (buttonText) {
        buttonText.textContent = isSubscription
          ? 'SUBSCRIBE NOW'
          : 'JOIN THE FOUNDING 100';
      }
    }
  }}

  function initialize() {
    updateWording();

    const observer = new MutationObserver(updateWording);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', updateWording);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();